import {
  SET_RUNTIME_VARIABLE,
  SET_AJAX_PENDING,
  SET_AJAX_ERROR,
  RUNTIME_MODAL,
  RUNTIME_SNACKBAR,
  RUNTIME_AJAX_PENDING,
  RUNTIME_AJAX_SUCCESS,
  RUNTIME_AJAX_ERROR,
  ACTION_REHYDRATE,
} from '../constants';
import moment from 'moment';

export default function runtime(state = { ajax: {} }, action) {
  switch (action.type) {
    case SET_RUNTIME_VARIABLE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case SET_AJAX_PENDING:
      return {
        ...state,
        ajaxError: null,
        ajaxPending: action.payload.value ? moment().valueOf() : false,
      };
    case SET_AJAX_ERROR:
      return {
        ...state,
        ajaxError: action.payload.value,
        ajaxPending: false,
      };
    case RUNTIME_MODAL: {
      const newState = {
        ...state,
        modal: {
          ...state.modal,
        },
      };
      newState.modal[action.payload.modalId] = action.payload.value;
      return newState;
    }
    case RUNTIME_SNACKBAR: {
      const newState = {
        ...state,
        snackbar: {
          ...state.snackbar,
        },
      };
      newState.snackbar.open = action.payload.open;
      newState.snackbar.message = action.payload.message;
      return newState;
    }

    case RUNTIME_AJAX_PENDING: {
      const newState = {
        ...state,
        ajax: {
          ...state.ajax,
        },
      };
      newState.ajax[action.payload.requestId] = { pending: true };
      return newState;
    }

    case RUNTIME_AJAX_SUCCESS: {
      const newState = {
        ...state,
        ajax: {
          ...state.ajax,
        },
      };
      newState.ajax[action.payload.requestId] = {
        success: true,
        result: action.payload.result,
      };
      return newState;
    }

    case RUNTIME_AJAX_ERROR: {
      const newState = {
        ...state,
        ajax: {
          ...state.ajax,
        },
      };
      newState.ajax[action.payload.requestId] = {
        pending: false,
        error: action.payload.result,
      };
      return newState;
    }

    case ACTION_REHYDRATE:
      return {
        ...state,
        persistentStateLoaded: true,
      };
    default:
      return state;
  }
}
